const pad2 = (n: number) => String(n).padStart(2, '0')

// BE LocalDateTime 이 @JsonFormat 없으면 [yyyy,MM,dd,HH,mm,ss,(nano)] 배열로 직렬화됨 — 배열/문자열 모두 안전 처리
/** → YYYY-MM-DD (없으면 '-') */
export const formatDate = (value: unknown): string => {
  if (Array.isArray(value)) {
    const [y, mo = 1, d = 1] = value as number[]
    return `${y}-${pad2(mo)}-${pad2(d)}`
  }
  return typeof value === 'string' && value ? value.slice(0, 10) : '-'
}

/** → YYYY-MM-DD HH:mm:ss (없으면 '-'). 'T' 구분자는 공백으로 치환 */
export const formatDateTime = (value: unknown): string => {
  if (Array.isArray(value)) {
    const [y, mo = 1, d = 1, h = 0, mi = 0, s = 0] = value as number[]
    return `${y}-${pad2(mo)}-${pad2(d)} ${pad2(h)}:${pad2(mi)}:${pad2(s)}`
  }
  return typeof value === 'string' && value ? value.slice(0, 19).replace('T', ' ') : '-'
}

// 반복 사용 리터럴 상수화 (중복 문자열 방지)
// 휴대폰번호 형식 — 가입 화면(OktaSignUp)과 동일 규칙
export const PHONE_REGEX = /^01[0-9]{8,9}$/

export const SNACK_SUCCESS = 'success' as const
export const EDITABLE_TEXT_CLASS = 'editable-cell-text'
export const EDITABLE_SELECT_CLASS = 'editable-cell-select'
// 오버레이 팝업 에디터(enterprise) — inline agSelectCellEditor 가 편집 시 그리드 본문 레이아웃을
// 흔들어(내부 viewport 0 붕괴) 그리드가 사라지던 문제 회피 + 디자인/폰트 일관성
export const AG_SELECT_EDITOR = 'agRichSelectCellEditor'
